import { Navigate, useLocation } from 'react-router-dom';

/**
 * Maps legacy `/onboarding/*` URLs to `/webAppOnboarding/*`, preserving path suffix and query.
 */
export function LegacyOnboardingRedirect() {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/onboarding\/?/, '');
  const path = suffix.length > 0 ? `/webAppOnboarding/${suffix}` : '/webAppOnboarding';
  const to = `${path}${location.search}${location.hash}`;
  return <Navigate to={to} replace />;
}
